import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User, Client } from '../types';

interface AuthState {
  user: User | null;
  client: Client | null;
  token: string | null;
  refreshToken: string | null;
  isAuthenticated: boolean;

  // Actions
  setAuth: (token: string, refreshToken: string, user: User, client: Client) => void;
  clearAuth: () => void;
  updateTokens: (token: string, refreshToken: string) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      client: null,
      token: null,
      refreshToken: null,
      isAuthenticated: false,

      setAuth: (token, refreshToken, user, client) => {
        set({
          token,
          refreshToken,
          user,
          client,
          isAuthenticated: true,
        });
      },

      clearAuth: () => {
        set({
          token: null,
          refreshToken: null,
          user: null,
          client: null,
          isAuthenticated: false,
        });
      },

      updateTokens: (token, refreshToken) => {
        set({ token, refreshToken });
      },
    }),
    {
      name: 'auth-storage',
      // Persist all auth-related state
      partialize: (state) => ({
        token: state.token,
        refreshToken: state.refreshToken,
        user: state.user,
        client: state.client,
        isAuthenticated: state.isAuthenticated,
      }),
      // Rehydrate the state on load
      onRehydrateStorage: () => (state) => {
        // After rehydration, verify if we still have valid auth
        if (state && state.token && state.user && state.client) {
          state.isAuthenticated = true;
        } else if (state) {
          state.isAuthenticated = false;
        }
      },
    }
  )
);
